import React from "react";
import { IP } from "../../internalServer"

function MyFeedTour({ setStepsEnabled, setHomeScreenWalkThroughPopup, studentDetail }) {
  console.log("studentDetail", studentDetail)
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/myfeed_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              {<img
                src={
                  studentDetail?.profile_picture
                    ? IP + studentDetail?.profile_picture.replace(/^\./, "")
                    : studentDetail?.gender === "M"
                      ? studentDetail?.avatar_profile ? '/images/Boys/' + studentDetail?.avatar_profile + '.webp'
                        : "/images/Student_boy_pic.png"
                      : studentDetail?.gender === "F"
                        ? studentDetail?.avatar_profile ? '/images/Girls/' + studentDetail?.avatar_profile + '.webp'
                          : "/images/Student_girl_pic.png"
                        : "/images/default image.png"
                }
                alt="icon"
                className="prifilePicImg"
                onError={(e) => {
                  if (studentDetail?.gender === "M") {
                    e.target.src = studentDetail?.avatar_profile ? '/images/Boys/' + studentDetail?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                  } else if (studentDetail?.gender === "F") {
                    e.target.src = studentDetail?.avatar_profile ? '/images/Girls/' + studentDetail?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                  } else {
                    e.target.src = "/images/default image.png"
                  }
                }}
              />}
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to my feed section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="/images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Energize Your Day by Daily Motivational Tweets
            </p>
            <hr></hr>
            <p className="textColor2">
              2. Get Inspired by Daily Stories to better Morally and Knowledgeably.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Quick Access to the Upcoming Lectures.
            </p>
            <hr></hr>
            <p className="textColor2">
              4. Get Information of School Notices.
            </p>
            <hr></hr>
            <p className="textColor2" id="last-paragraph">
              5. Personalize your Avatar Profile.
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              className="leftBtn"
              id="myfeedtour"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyFeedTour;
